import React from 'react';
import ModalHeader from 'components/ModalHeader';
import ModalHeaderWithClose from 'components/ModalHeaderWithClose';
import Modal from 'components/Modal';
import * as ColumnTypes from './ColumnTypes';
import {FormattedMessage} from 'react-intl';
import {NUMERIC_OPERANDS, STRING_OPERANDS} from 'constants/FilterConstants';
import OperandShorthand from 'components/OperandShorthand';
import styles from './OperandStep.css?module';
import cx from 'classnames';
import ButtonUnstyled from 'components/ButtonUnstyled';

const OperandListItem = ({operand, onClick}) => (
  <ButtonUnstyled className={styles.operatorItem} onClick={onClick}>
    <div className={styles.operatorShorthand}>
      <OperandShorthand value={operand.value} />
    </div>
    <div className={styles.operatorName}>{operand.el}</div>
  </ButtonUnstyled>
);

class OperandStep extends React.Component {
  state = {
    isOpen: false,
  };

  handleClick = () => {
    this.props.onClick();
    this.setState({
      isOpen: true,
    });
  };

  handleSelect = operand => {
    this.props.onSelect(operand);
    this.setState({
      isOpen: false,
    });
  };

  handleRequestModalClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const {selected, operands, operand} = this.props;

    return (
      <div className={styles.container}>
        <ButtonUnstyled
          className={cx({
            [styles.circle]: true,
            [styles.circleSelected]: selected,
          })}
          onClick={this.handleClick}
        >
          <OperandShorthand value={operand && operand.value} />
        </ButtonUnstyled>
        <Modal isOpen={this.state.isOpen}>
          <ModalHeaderWithClose onClose={this.handleRequestModalClose}>
            <ModalHeader>
              <FormattedMessage
                id="OperandStep__Label"
                description="Label for filter operand select list"
                defaultMessage="Operator"
              />
            </ModalHeader>
          </ModalHeaderWithClose>
          {operands.map(o => (
            <OperandListItem
              key={o.value}
              operand={o}
              onClick={() => this.handleSelect(o)}
            />
          ))}
        </Modal>
      </div>
    );
  }
}

const StringOperandStep = props => (
  <OperandStep operands={STRING_OPERANDS} {...props} />
);

const NumericOperandStep = props => (
  <OperandStep operands={NUMERIC_OPERANDS} {...props} />
);

export default ({column, ...rest}) => {
  const type = column ? column.type : null;
  switch (type) {
    case ColumnTypes.STRING:
      return <StringOperandStep {...rest} />;
    default:
      return <NumericOperandStep {...rest} />;
  }
};
